import { withStyles } from "@material-ui/core";
import DigitalTurbineLogoIcon from "assets/icons/DigitalTurbineLogoIcon";

const styles = () => ({
  "@keyframes dt-spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
  loadingIndicator: {
    position: "absolute",
    top: "50%",
    left: "50%",
    display: "inline-flex",
    animation: "$dt-spin 1s linear infinite",
  },
});

const LoadingIndicator = (props) => {
  // circleColor tints the whole logo a single colour (e.g. white on the
  // purple button); omit it to keep the multi-coloured brand logo.
  const { classes, theme, size, circleColor, ...rest } = props;
  const dimension = size || 60;
  const offset = dimension / -2;
  return (
    <div
      {...rest}
      className={classes.loadingIndicator}
      style={{ marginTop: offset, marginLeft: offset }}
    >
      <DigitalTurbineLogoIcon
        width={dimension}
        height={dimension}
        color={circleColor}
      />
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(LoadingIndicator);
